import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { MEDIA_BREAKPOINTS } from '../../../../mediaQueries.const';
import { Link } from '../../../partials/link/Link';
import { baseUnit } from '../../../../theming/baseUnitDefinition';
import { AnimationDirection, AnimationDirectionType } from './menuAnimations.util';
import { reducedLogoHeightFactor } from './header.utils';

export interface LogoProps {
    svgLarge: string;
    svgSmall: string;
    svgLargeViewBox: string;
    svgSmallViewBox: string;
    alt: string;
    href: string;
    logoHeights?: { large: number; medium: number; small: number};
    menuAnimation?: AnimationDirectionType;
    reduceHeightAnimationDuration?: number;
}

export const createLogoHeights = (small: number, medium: number, large: number) => ({
  small,
  medium,
  large,
});
const defaultLogoHeights = createLogoHeights(24, 24, 24);

const getLogoStyle = (logoHeights: typeof defaultLogoHeights, menuAnimation: AnimationDirectionType, reduceHeightAnimationDuration: number) => {
  return StyleSheet.create({
    base: {
      [MEDIA_BREAKPOINTS.large]: {
        height: menuAnimation === AnimationDirection.UP ? `${logoHeights.large * reducedLogoHeightFactor}px` : `${logoHeights.large}px`,
      },
      [MEDIA_BREAKPOINTS.medium]: {
        height: `${logoHeights.medium}px`,
      },
      [MEDIA_BREAKPOINTS.small]: {
        height: `${logoHeights.small}px`,
      },
      alignItems: 'center',
      paddingRight: `${baseUnit}px`,
      transition: `${reduceHeightAnimationDuration}ms`,
    },
    largeSvg: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'inline-flex',
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'none',
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'none',
      },
    },
    smallSvg: {
      [MEDIA_BREAKPOINTS.large]: {
        display: 'none',
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'inline-flex',
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'inline-flex',
      },
    },
    image: {
      height: '100%',
    },
  });
};

const getImageResource = (svg: string) => {
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

export const Logo: React.FunctionComponent<LogoProps> = props => {
  const { href, alt, svgLarge, svgSmall, logoHeights = defaultLogoHeights, menuAnimation = AnimationDirection.NONE, reduceHeightAnimationDuration = 0 } = props;
  const style = getLogoStyle(logoHeights, menuAnimation, reduceHeightAnimationDuration);

  return (
    <React.Fragment>
      <Link className={css(style.largeSvg, style.base)} href={href}>
        <img className={css(style.image)} alt={alt} src={getImageResource(svgLarge)} />
      </Link>
      <Link className={css(style.smallSvg, style.base)} href={href}>
        <img className={css(style.image)} alt={alt} src={getImageResource(svgSmall)} />
      </Link>
    </React.Fragment>
  );
};
